import { render } from "./PricingGroup.vue?vue&type=template&id=511441da"
import script from "./PricingGroup.vue?vue&type=script&lang=js"
export * from "./PricingGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__